// assets
import { IconDashboard, IconGraph } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconGraph };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/merchant-home',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'profileSummary',
            title: 'Profile Summary',
            type: 'item',
            url: '/profile-summary',
            icon: icons.IconGraph,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
